<template>
  <div>
    <el-row>
      <el-col align="end">
        <showButtonPdf :type="1" label="Descargar Anexo Técnico"/>
      </el-col>
    </el-row>
    <span v-if="showField">
           <el-form-item
               label="1. Tipo de solicitud"
               prop="cat_acquisition_type_id"
               :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
                <el-select
                    style="width:100%"
                    v-model="requestForm.cat_acquisition_type_id"
                    filterable
                    :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                    @change="resetArticles(requestForm.cat_acquisition_type_id)"
                    placeholder="Seleccionar">
                    <el-option
                        v-for="(item,key) in catalogs.catAcquisitionType"
                        :key="key"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        <el-form-item
            label="Nombre del bien o servicio a contratar"
            prop="product_or_service_id"
            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
            <el-select
                style="width:100%"
                v-model="requestForm.product_or_service_id"
                filterable
                :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                @change="resetArticles(requestForm.cat_acquisition_type_id); checkIsOther(requestForm.product_or_service_id)"
                placeholder="[Se deberá de especificar el nombre completo del servicio o bien a
                                contratar, especificando si se trata de una adquisición, arrendamiento o
                                servicio]">
                <el-option
                    v-for="(item,key) in filterProductService(catalogs.catProductsOrServicesArticles)"
                    :key="key"
                    :label="(item.product_or_service? item.product_or_service.name: '') + ' /' + item.name "
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
      <!--v-if="requestForm.product_or_service_id == 45" -->
        <el-form-item
            v-if="enableIsOther == true"
            label="Describe otro"
            prop="name"
            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
            <el-input
                :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                v-model="requestForm.name"
                placeholder="Describe otro">
            </el-input>
        </el-form-item>
        <el-form-item
            v-if="requestForm.cat_acquisition_type_id == 4"
            label="Representaciones involucradas"
            prop="office_ids"
            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
            <el-select
                style="width:100%"
                v-model="requestForm.office_ids"
                filterable
                multiple
                :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                placeholder="Seleccionar">
                <el-option
                    v-for="(item,key) in catalogs.catOffice"
                    :key="key"
                    :label="item.representation_name"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item
            label="2. Objeto del bien o servicio a contratar"
            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
            prop="backgroundOfObjectives">
          <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.backgroundOfObjectives }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
          <el-button
              type="text"
              style="font-size: 13px"
              v-clipboard:copy="requestForm.backgroundOfObjectives"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
          >
            Copiar <i class="fas fa-copy"/>
          </el-button>
          <editor
              :init='init'
              id="backgroundOfObjectives"
              v-model="requestForm.backgroundOfObjectives"
              :disabled="true"
              placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
            </editor>
        </el-form-item>
        <el-form-item
            label="Objeto del bien o servicio a contratar (Objetivo general)"
            prop="goals"
            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
          <el-tooltip placement="top">
            <div slot="content" style="font-size: 12pt">
              {{ descriptions.goals }}
            </div>
            <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
          <el-button
              type="text"
              style="font-size: 13px"
              v-clipboard:copy="requestForm.goals"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
          >
            Copiar <i class="fas fa-copy"/>
          </el-button>
          <el-button
              type="text"
              v-if="infoUser.profile == 1"
              @click="showModalDescription(descriptions.goals, 'goals')"
              style="font-size: 13px">
            Actualizar Marca de agua <i class="fas fa-align-justify"></i>
          </el-button>
          <editor
              :init='init'
              id="goals"
              v-show="true"
              v-model="requestForm.goals"
              :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
              placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado"></editor>
        </el-form-item>
        <el-form-item
            v-show="checkShowField"
            label="Objeto del bien o servicio a contratar (Objetivos específicos)"
            prop="specificObjectives">
          <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.specificObjectives }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
          <el-button
              type="text"
              style="font-size: 13px"
              v-clipboard:copy="requestForm.specificObjectives"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError">
            Copiar <i class="fas fa-copy"/>
          </el-button>
          <el-button
              type="text"
              v-if="infoUser.profile == 1"
              @click="showModalDescription(descriptions.specificObjectives, 'specificObjectives')"
              style="font-size: 13px">
            Actualizar Marca de agua <i class="fas fa-align-justify"></i>
          </el-button>
          <editor
              :init='init'
              id="specificObjectives"
              v-model="requestForm.specificObjectives"
              :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
              placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
            </editor>
      </el-form-item>
        </span>
    <el-form-item label="1. Nombre del bien o servicio a contratar">
      <label style="margin-left: 40px">
        <b>{{ filterServiceName(requestForm.service_name_id) }}</b>
      </label>
    </el-form-item>
    <el-form-item label="2. Objeto del bien o servicio a contratar">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.backgroundOfObjectives }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.backgroundOfObjectives"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.backgroundOfObjectives, 'backgroundOfObjectives')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="backgroundOfObjectives3"
          v-model="requestForm.backgroundOfObjectives"
          :disabled="true"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <div class="tip">
      [Establecer el periodo de la fecha de inicio y fin de la contratación]
    </div>
    <el-row :gutter="5">
      <el-col :span="12">
        <el-form-item
            label="3. Vigencia (Fecha inicio)"
            prop="validity"
            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
          <el-date-picker
              :picker-options="pickerOptions"
              :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
              :editable="false"
              @change="requestForm.validityEnd = null"
              v-model="requestForm.validity"
              type="date"
              placeholder="Establecer el periodo de inicio de la contratación"
              style="width: 100%"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
            label="Fecha fin"
            prop="validityEnd"
            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
          <el-date-picker
              :picker-options="pickerOptionsTwo(requestForm.validity)"
              :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
              :editable="false"
              v-model="requestForm.validityEnd"
              type="date"
              placeholder="Establecer el periodo de fin de la contratación"
              style="width: 100%"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :span="8">
        <el-form-item
            label="¿Se trata de una contratación Plurianual?">
          <el-switch
              :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
              style="display: block; margin-top: 40px; left: 50px"
              v-model="requestForm.isMultiyear"
              active-color="#13ce66"
              active-text="Sí"
              inactive-text="No">
          </el-switch>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item
        label="4. Alcance"
        prop="scope"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.scope }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.scope"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.scope, 'scope')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="scope"
          v-model="requestForm.scope"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        label="5. Arrendamiento del bien o servicio a contratar Y características"
        prop="articles"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
      <el-table
          border
          stripe
          :data="requestForm.articles"
          size="small" style="width: 100%">
        <el-table-column
            label="Dictamen Técnico Informático Regional"
            align="center">
          <el-table-column
              align="center"
              label="Bien o Servicio"
              min-width="180">
            <template slot-scope="props">
              {{ filterService(props.row) }}
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="Cantidad"
              min-width="180">
            <template slot-scope="props">
              {{ props.row.amount }}
            </template>
          </el-table-column>
          <el-table-column
              align="justify"
              label="Características Generales"
              min-width="180">
            <template slot-scope="props">
              {{ props.row.particularDescription }}
            </template>
          </el-table-column>
          <el-table-column
              align="justify"
              label="Especificaciones Técnicas"
              min-width="180">
            <template slot-scope="props">
              {{ props.row.technicalDescription }}
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="Representaciones"
              min-width="180">
            <template slot-scope="props">
              <el-input
                  style=" margin-top: 5px"
                  v-for="(item,key6) in filterOffice(catalogs.catOffice, props.row.office_ids)"
                  :key="key6"
                  :value="item.representation_name"
                  disabled>
              </el-input>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>

    </el-form-item>
    <el-form-item
        v-if="checkShowField"
        label="6. Especificaciones técnicas"
        prop="technicalCharacteristics"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.technicalCharacteristics }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.technicalCharacteristics"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.technicalCharacteristics, 'technicalCharacteristics')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="technicalCharacteristics"
          v-model="requestForm.technicalCharacteristics"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        :label="checkShowField ?'7.  Transferencia del conocimiento. (Solo si aplica)'
                :'6.  Transferencia del conocimiento. (Solo si aplica)'"
        prop="knowledgeTransfer">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.knowledgeTransfer }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.knowledgeTransfer"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.knowledgeTransfer, 'knowledgeTransfer')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="knowledgeTransfer"
          v-model="requestForm.knowledgeTransfer"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        :label="checkShowField ?'8. Niveles de Servicio'
                :'7. Niveles de Servicio'"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
        prop="serviceLevels">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.serviceLevels }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.serviceLevels"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.serviceLevels, 'serviceLevels')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="serviceLevels"
          v-model="requestForm.serviceLevels"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
      <br>
      <div align="right">
        <el-button type="primary" @click="addLevel"
                   :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1">
          Agregar Nivel
        </el-button>
      </div>
      <br>
      <el-table :data="requestForm.levels"
                border stripe
                style="width: 100%">
        <el-table-column align="center" label="Nivel">
          <template slot-scope="props">
            <el-row :gutter="5">
              <el-col :span="8">
                <label>Nivel {{ (props.$index + 1) }}</label>
              </el-col>
              <el-col :span="16">
                <el-input :rows="5"
                          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                          type="textarea"
                          resize="none"
                          v-model="props.row.level">
                </el-input>
                <div align="left">
                                    <span class="count-character">
                        			    max	1000/{{ countCharacter(props.row.level) }}
                    			    </span>
                </div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Concepto" prop="concept">
          <template slot-scope="props">
            <el-row :gutter="5">
              <el-col :span="24">
                <el-input type="textarea"
                          :rows="5"
                          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                          resize="none"
                          v-model="props.row.concept">
                </el-input>
                <div align="left">
                                    <span class="count-character">
                        			    max	1000/{{ countCharacter(props.row.concept) }}
                    			    </span>
                </div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="Acciones" align="center">
          <template slot-scope="props">
            <el-tooltip class="item" effect="dark" content="Eliminar">
              <el-button type="danger"
                         size="small"
                         :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                         icon="fas fa-trash"
                         @click="removeLavelAux(props.row)"/>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-form-item>
    <Docs v-if="checkShowField" :onlyRead=" onlyRead== true ? true: false" :sectionId="1">
      <div slot="main">
        Anexos
      </div>
    </Docs>
    <el-form-item
        :label="checkShowField ?'9. Términos y condiciones de entrega y de aceptación'
                :'8. Términos y condiciones de entrega y de aceptación'"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
        prop="termsAndConditions">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.problemToSolve }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.termsAndConditions"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.termsAndConditions, 'termsAndConditions')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="termsAndConditions"
          v-model="requestForm.termsAndConditions"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <Docs :onlyRead=" onlyRead== true ? true: false" :sectionId="2">
      <div slot="main">
        Anexos
      </div>
    </Docs>
    <el-form-item
        :label="checkShowField ?'10. Tiempo de respuesta de soporte y servicio'
                :'9. Tiempo de respuesta de soporte y servicio'"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
        prop="responseTime">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.responseTime }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.responseTime"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.responseTime, 'responseTime')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="responseTime"
          v-model="requestForm.responseTime"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
      <br>
      <span v-if="!checkShowField">
               <div align="right">
                    <el-button type="primary" @click="addSupport"
                               :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1">
                        Agregar Tiempo de Respuesta
                    </el-button>
               </div>
               <br>
                <el-table :data="requestForm.supports"
                          border stripe
                          style="width: 100%">
                    <el-table-column align="center" type="index" label="#"/>
                    <el-table-column align="center" label="Concepto">
                        <template slot-scope="props">
                           <el-input :rows="5"
                                     :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                     type="textarea"
                                     resize="none"
                                     v-model="props.row.concept"/>
                            <div align="left">
                                 <span class="count-character">
                        			max	1000/{{ countCharacter(props.row.concept) }}
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="Respuesta de soporte" prop="concept">
                        <template slot-scope="props">
                            <el-row :gutter="5">
                                <el-col :span="24">
                                    <el-input type="textarea"
                                              :rows="5"
                                              :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                              resize="none"
                                              v-model="props.row.response">
                                    </el-input>
                                      <div align="left">
                                          <span class="count-character">
                        			         max 1000/{{ countCharacter(props.row.response) }}
                    			           </span>
                                      </div>
                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column label="Acciones" align="center">
                        <template slot-scope="props">
                            <el-tooltip class="item" effect="dark" content="Eliminar">
                                <el-button type="danger"
                                           size="small"
                                           :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                           icon="fas fa-trash"
                                           @click="removeSupportAux(props.row)"/>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </span>
    </el-form-item>
    <el-form-item
        :label="checkShowField ?'11. Cláusula de confidencialidad Y protección de datos personales'
                :'10. Cláusula de confidencialidad Y protección de datos personales'"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
        prop="confidentialityClause">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.problemToSolve }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.confidentialityClause"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-input v-model="requestForm.confidentialityClause"
                type="textarea"
                :disabled="true"
                :autosize="{ minRows: 8, maxRows: 8}"
                placeholder="">
      </el-input>


    </el-form-item>


    <el-form-item
        v-show="checkShowField"
        label="12. Seguimiento del servicio"
        prop="serviceTracking">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.serviceTracking }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.serviceTracking"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.serviceTracking, 'serviceTracking')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="serviceTracking"
          v-model="requestForm.serviceTracking"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        v-show="checkShowField"
        label="13. Entregables"
        prop="deliverables">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.deliverables }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.deliverables"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.deliverables, 'deliverables')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="OldDeliverables"
          v-model="requestForm.deliverables"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        v-show="!checkShowField"
        label="11. Entregables"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
        prop="deliverables">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.deliverables }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.deliverables"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.deliverables, 'deliverables')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="deliverables"
          v-model="requestForm.deliverables"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
      <br>
      <span v-if="!checkShowField">
               <div align="right">
                    <el-button type="primary" @click="addDeliverable"
                               :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1">
                        Agregar Entregable
                    </el-button>
               </div>
               <br>
                <el-table :data="requestForm.progress"
                          border stripe
                          style="width: 100%">
                    <el-table-column align="center" type="index" label="#"/>
                    <el-table-column align="center" label="Entregable">
                        <template slot-scope="props">
                           <el-input :rows="5"
                                     :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                     type="textarea"
                                     resize="none"
                                     v-model="props.row.deliverable"/>
                            <div align="left">
                                 <span class="count-character">
                        			max	1000/{{ countCharacter(props.row.deliverable) }}
                                 </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="Concepto" prop="concept">
                        <template slot-scope="props">
                            <el-row :gutter="5">
                                <el-col :span="24">
                                    <el-input type="textarea"
                                              :rows="5"
                                              :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                              resize="none"
                                              v-model="props.row.concept">
                                    </el-input>
                                    <div align="left">
                                        <span class="count-character">
                        			        max	1000/{{ countCharacter(props.row.concept) }}
                                        </span>
                                    </div>
                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="Periodicidad" prop="periodicity">
                        <template slot-scope="props">
                             <el-input type="textarea"
                                       :rows="5"
                                       :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                       resize="none"
                                       v-model="props.row.periodicity"></el-input>
                                <div align="left">
                                     <span class="count-character">
                        			    max	1000/{{ countCharacter(props.row.periodicity) }}
                                     </span>
                                </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Acciones" align="center">
                        <template slot-scope="props">
                            <el-tooltip class="item" effect="dark" content="Eliminar">
                                <el-button type="danger"
                                           size="small"
                                           :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                           icon="fas fa-trash"
                                           @click="removeDeliverableAux(props.row)"/>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </span>
    </el-form-item>
    <el-form-item
        v-show="!checkShowField"
        label="12. Sanciones y penalizaciones"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
        prop="sanctions">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.sanctions }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.sanctions"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.sanctions, 'sanctions')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="descsanctions"
          v-model="requestForm.sanctions"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        v-show="checkShowField"
        label="14. Sanciones y penalizaciones"
        prop="sanctions">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.sanctions }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.sanctions"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.sanctions, 'sanctions')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="OldSanctions"
          v-model="requestForm.sanctions"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        v-show="checkShowField"
        label="15. Penalizaciones"
        prop="penalties">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.penalties }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.penalties"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.penalties, 'penalties')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="penalties"
          v-model="requestForm.penalties"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        v-show="checkShowField"
        label="16. Cronograma del servicio"
        prop="schedule">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.schedule }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.schedule"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.schedule, 'schedule')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="OldSchedule"
          v-model="requestForm.schedule"
          :disabled="onlyRead == true ? true: false"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        v-show="!checkShowField"
        label="13. Cronograma del servicio"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
        prop="schedule">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.schedule }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.schedule"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.schedule, 'schedule')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="schedule"
          v-model="requestForm.schedule"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
      <br>
      <span v-if="!checkShowField">
               <div align="right">
                    <el-button type="primary" @click="addCalendar"
                               :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1">
                        Agregar Cronograma
                    </el-button>
               </div>
               <br>
                <el-table :data="requestForm.calendar"
                          border stripe
                          style="width: 100%">
                    <el-table-column align="center" type="index" label="#"/>
                    <el-table-column align="center" label="Actividad">
                        <template slot-scope="props">
                           <el-input :rows="5"
                                     :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                     type="textarea"
                                     resize="none"
                                     v-model="props.row.activity"/>
                             <div align="left">
                                 <span class="count-character">
                        			max	2000/{{ countCharacter(props.row.activity) }}
                    			</span>
                             </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="Fecha de Inicio" prop="startDate">
                        <template slot-scope="props">
                           <el-date-picker
                               :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                               :editable="false"
                               @change="props.row.endDate = null"
                               v-model="props.row.startDate"
                               type="date"
                               placeholder="Selecciona una fecha"
                               style="width: 100%"
                               format="dd/MM/yyyy"
                               value-format="yyyy-MM-dd">
						    </el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="Fecha de término " prop="endDate">
                        <template slot-scope="props">
                            <el-date-picker
                                :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                :picker-options="pickerOptions2(props.row.startDate)"
                                :editable="false"
                                v-model="props.row.endDate"
                                type="date"
                                placeholder="Selecciona una fecha"
                                style="width: 100%"
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd">
						</el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="Responsable de Actividad">
                        <template slot-scope="props">
                           <el-input :rows="5"
                                     :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                     type="textarea"
                                     resize="none"
                                     v-model="props.row.responsible"/>
                            <div align="left">
                                <span class="count-character">
                        			max	2000/{{ countCharacter(props.row.responsible) }}
                    			</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Acciones" align="center">
                        <template slot-scope="props">
                            <el-tooltip class="item" effect="dark" content="Eliminar">
                                <el-button type="danger"
                                           size="small"
                                           :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                           icon="fas fa-trash"
                                           @click="removeCalendarAux(props.row)"/>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </span>

    </el-form-item>

    <Docs checkShowField :onlyRead=" onlyRead== true ? true: false" :sectionId="3">
      <div slot="main">
        Anexos
      </div>
    </Docs>

    <el-form-item
        v-if="checkShowField"
        label="17. Garantía de cumplimiento de contrato"
        prop="contractCompliance">

      <el-switch
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          style="display: block"
          v-model="requestForm.contractComplianceCheck"
          active-color="#13ce66"
          active-text="Sí"
          inactive-text="No">
      </el-switch>


    </el-form-item>

    <el-form-item
        label="17. Garantía de cumplimiento de contrato"
        prop="contractCompliance"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }"
        v-if="requestForm.contractComplianceCheck">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.contractCompliance }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.contractCompliance"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.contractCompliance, 'contractCompliance')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="contractCompliance"
          v-model="requestForm.contractCompliance"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        v-show="!checkShowField"
        label="14. Términos y forma de pago"
        prop="paymentType"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.paymentType }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.paymentType"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.paymentType, 'paymentType')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="paymentType"
          v-model="requestForm.paymentType"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>

    </el-form-item>

    <el-form-item
        v-if="checkShowField"
        label="18. Forma de pago"
        prop="OldPaymentType"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.paymentType }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.paymentType"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.paymentType, 'paymentType')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="OldPaymentType"
          v-model="requestForm.paymentType"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        v-if="checkShowField"
        label="19. Glosario de términos"
        prop="glossary"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
      <el-tooltip placement="top">
        <div slot="content" style="font-size: 12pt">
          {{ descriptions.glossary }}
        </div>
        <i style="font-size: 13px" class="fas fa-info"/>
      </el-tooltip>
      <el-button
          type="text"
          style="font-size: 13px"
          v-clipboard:copy="requestForm.glossary"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
      >
        Copiar <i class="fas fa-copy"/>
      </el-button>
      <el-button
          type="text"
          v-if="infoUser.profile == 1"
          @click="showModalDescription(descriptions.glossary, 'glossary')"
          style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
      <editor
          :init='init'
          id="glossary"
          v-model="requestForm.glossary"
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
      </editor>
    </el-form-item>
    <el-form-item
        v-if="checkShowField"
        label="Partida presupuestal"
        prop="budget_id"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
      <el-select
          style="width:100%"
          v-model="requestForm.budget_id"
          filterable
          clearable
          placeholder="Seleccionar">
        <el-option
            v-for="(item,key) in catalogs.catBudget"
            :key="key"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
        v-if="checkShowField"
        label="Sub partida presupuestal"
        prop="sub_budget_id"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
      <el-select
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          style="width:100%"
          v-model="requestForm.sub_budget_id"
          filterable
          clearable
          placeholder="Seleccionar">
        <el-option
            v-for="(item,key) in filterSubBudget(catalogs.catSubBudget, requestForm.budget_id)"
            :key="key"
            :label="item.code+ '-' + item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
        v-if="checkShowField"
        label="Moneda local"
        prop="local_currency"
        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
      <el-select
          :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
          style="width:100%"
          v-model="requestForm.local_currency"
          filterable
          clearable
          placeholder="Seleccionar">
        <el-option
            v-for="(item,key) in catalogs.catCurrencies"
            :key="key"
            :label="item.name+' '+item.code"
            :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <showButtonPdf :type="1" label="Descargar Anexo Técnico"/>
    <Docs :onlyRead=" onlyRead== true ? true: false" :sectionId="4">
      <div slot="main">
        Suba su documento firmado correspondeinte al "Anexo Técnico"
      </div>
    </Docs>
    <br/>
    <Docs :onlyRead="requestForm.last_log && requestForm.last_log.cat_acquisition_status_id == 13 ? false: true"
          :sectionId="7" v-if="requestForm.last_log && requestForm.last_log.cat_acquisition_status_id == 13">
      <div slot="main">
        Documentación Validación del OIC
      </div>
    </Docs>
    <el-dialog
        :fullscreen="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="Redacción sugerida"
        :visible.sync="modalDescription">
      <el-form
               @submit.native.prevent>
        <el-row>
          <el-col>
            <el-input
                type="textarea"
                :rows="10"
                v-model="modelDescription.text"/>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveDescription()">
          Guardar
        </el-button>
        <el-button @click="modelDescription.text = ''; modalDescription = false">
          cerrar
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
import Label from '@/components/views/acquisition/partials/Label'
import Docs from '@/components/views/acquisition/partials/Docs'
import showButtonPdf from '@/components/views/acquisition/partials/showButtonPdf'
import Articles from '@/components/views/acquisition/partials/Articles'

import Vue from 'vue'
import tinymce from 'vue-tinymce-editor';
import {Notification} from "element-ui";

Vue.component('tinymce', tinymce);

export default {

  props: {
    showField: {

      type: Boolean
    }
  },

  components: {
    Label,
    Docs,
    showButtonPdf,
    Articles
  },
  data() {
    return {
      enableIsOther: false,
      pickerOptions: {
        disabledDate(time) {
          let yesterday = moment().subtract(1, 'day');
          return time.getTime() < yesterday;
        }
      },
      checkShowField: false,
      modelDescription: {},
      modalDescription: false,
      init: {
        language_url: '/tinymce/langs/es_419.js',
        language: 'es_419',
        skin_url: 'tinymce/skins/ui/oxide',
        // skin_url: 'tinymce/skins/ui/oxide-dark', // color oscuro
        height: 350,
        // inline: true,
        menubar: false,
        toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | ' +
            'bullist numlist outdent indent | link image | print preview media fullscreen',
        content_style: 'body { font-family:Montserrat; font-size:12px }'
      },

    }
  },

  mounted() {
    this.checkShow();
  },
  computed: {
    ...mapGetters("form", {
      requestForm: "requestForm",
      catalogs: "catalogs",
      onlyRead: "onlyRead",
      optionEditor: "optionEditor",
      descriptions: "descriptionsAreas"
    }),
    infoUser() {
      return this.$store.state.user
    },
  },
  methods: {
    ...mapActions('form', {
      fetchDescriptions: "fetchDescriptions"
    }),
    ...mapMutations('form', {
      resetArticles: "resetArticles",
      addLevel: "addLevel",
      removeLevel: "removeLevel",
      addSupport: "addSupport",
      removeSupport: "removeSupport",
      addDeliverable: "addDeliverable",
      removeDeliverable: "removeDeliverable",
      addCalendar: "addCalendar",
      removeCalendar: "removeCalendar",
    }),
    filterProductService(data) {
      if (!data) return [];
      return data; //= data.filter((item)=> item.type_product_or_service_id == 6);
    },
    checkShow() {
      if (this.requestForm) {
        let _checkShowField = moment(this.requestForm.created_at).format('Y');
        _checkShowField < 2020 ? this.checkShowField = true : this.checkShowField = false
      }
      this.checkShowField = false;
    },

    filterSubBudget(catSubBudget, budget_id) {
      if (!catSubBudget || !budget_id) return [];
      return catSubBudget = catSubBudget.filter((item) => item.cat_budget_id == budget_id);
    },
    pickerOptionsTwo(date) {

      return {
        disabledDate(time) {
          if (!date) {
            return true;
          }
          let day = moment(date);
          return time.getTime() < day;
        }
      }

    },

    checkIsOther(value) {
      this.enableIsOther = false;
      if (value != '') {
        let _find = this.catalogs.catProductsOrServicesArticles.filter((up) => {
          if (up.id == value) {
            if (up.name == 'Otros') {
              this.enableIsOther = true;
            }
          }
        });
      }
    },

    removeLavelAux(item) {
      this.$confirm('¿Desea eliminar').then(confirm => {
        this.removeLevel(item);
      }).catch(e => {

      });
    },

    removeSupportAux(item) {
      this.$confirm('¿Desea eliminar').then(confirm => {
        this.removeSupport(item);
      }).catch(e => {

      });
    },
    removeDeliverableAux(item) {
      this.$confirm('¿Desea eliminar').then(confirm => {
        this.removeDeliverable(item);
      }).catch(e => {

      });
    },

    removeCalendarAux(item) {
      this.$confirm('¿Desea eliminar').then(confirm => {
        this.removeCalendar(item);
      }).catch(e => {

      });
    },

    pickerOptions2(date) {

      return {
        disabledDate(time) {
          if (!date) {
            return true;
          }
          let day = moment(date);
          return time.getTime() < day;
        }
      }

    },

    filterOffice(catOffice, office_ids) {
      if (!catOffice || !office_ids) return [];

      let array = [];
      array = _.intersectionWith(catOffice, office_ids,
          ({id}, item) => id == item
      );
      return array;
    },

    filterServiceName(serviceId) {
      let name = this.catalogs.serviceName.filter(up => up.id == serviceId);
      name = _.head(name);
      return name = name && name.name ? name.name : 'No se ha seleccionado bien o servicio';
    },

    filterService(data) {
      /*props.row.article.id == 7 ? props.row.article.name + ': ' + props.row.describeAnotherName :
          props.row.article.name*/
      if (data.article && data.article.id && data.article.name && (data.article.id == 7
          || data.article.id == 23 || data.article.id == 32 || data.article.id == 36
          || data.article.id == 40 || data.article.id == 45 || data.article.id == 54)) {
        return data.article.name + ': ' + data.article.name

      } else if (data.article && data.article.id && data.article.name) {
        return data.article.name
      } else {
        let name = this.catalogs.catProductsOrServicesArticles.filter(up => up.id == data.article_id);
        name = _.head(name);
        return name = name && name.name ? name.name : '--';
      }
    },
    countCharacter(count) {
      if (!count) return 0;
      if (count != '') {
        let _count = count.toString().length;
        return _count
      }
    },
    async onCopy(e) {
      try {
        await this.$copyText(e.text.replace(/(<([^>]+)>)/ig, '')).then(async function (ee) {
          Notification.success('Se copió el texto correctamente.')
        }, function (e) {
          console.log(e)
        })
      } catch (e) {
        console.log("copy clipboard ", e)
      }
    },
    onError: function (e) {
      alert('Failed to copy the text to the clipboard')
      console.log(e);
    },
    showModalDescription(text, model) {
      let _object = {
        text: text,
        model: model
      }
      this.modelDescription = Object.assign({}, _object);
      this.modalDescription = true;
    },
    saveDescription() {
      axios.post('/api/acquisitions/s-description', {
        description: this.modelDescription
      }).then(response => {
        if (response.data.success) {
          Notification.success(response.data.message);
          this.fetchDescriptions();
          this.modalDescription = false;
        } else {
          Notification.error(response.data.message)
        }
      }).catch(e => {
        console.log("error ", e);
        Notification.error('No se pudo procesar su solicitud.')
      })
    }


  },


}
</script>

<style scoped>

</style>